import { endsWith, isArray, isObject } from "lodash";
import { Middleware, AnyAction } from "@reduxjs/toolkit";
import { FAILURE_SUBTYPE, REQUEST_SUBTYPE, SUCCESS_SUBTYPE } from "./apiCallMiddleware";

const defaultPayload = {
  isLoading: false,
  error: null,
  fieldErrors: null,
};

interface MiddlewarePayloadAction extends AnyAction {
  payload?: {
    result?: any;
    error?: any;
    fieldErrors?: any;
  };
  subtype?: string;
  response?: any;
}

/**
 * Middleware that formats the response payload based on action subtypes.
 * Compatible with Redux Toolkit.
 */
const payloadMiddleware: Middleware = () => (next) => (action) => {
  const newAction = action as MiddlewarePayloadAction;
  // Clone the action to avoid mutating the original

  // Early return if there's no subtype (not an API action)
  if (!newAction.subtype) {
    return next(newAction);
  }

  const { result, error, fieldErrors } = newAction.payload || {};

  if (endsWith(newAction.subtype, REQUEST_SUBTYPE)) {
    newAction.response = {
      ...defaultPayload,
      isLoading: true,
    };
  } else if (endsWith(newAction.subtype, FAILURE_SUBTYPE)) {
    newAction.response = {
      ...defaultPayload,
      error,
      fieldErrors,
    };
  } else if (endsWith(newAction.subtype, SUCCESS_SUBTYPE)) {
    if (isArray(result) || !isObject(result)) {
      newAction.response = {
        ...defaultPayload,
        data: result,
      };
    } else {
      newAction.response = {
        ...defaultPayload,
        ...result,
      };
    }
  }

  return next(newAction);
};

export default payloadMiddleware;
